import { render } from "./testTemplate.vue?vue&type=template&id=73e1d839&scoped=true"
import script from "./testTemplate.vue?vue&type=script&lang=js"
export * from "./testTemplate.vue?vue&type=script&lang=js"

import "./testTemplate.vue?vue&type=style&index=0&id=73e1d839&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/rentalkenya_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73e1d839"]])

export default __exports__